module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "forum-thread-summary"
  }, [_c('header', [_c('ul', {
    staticClass: "info-blocks"
  }, [_c('li', [_c('div', {
    staticClass: "info-label info-label-left"
  }, [_vm._v("\n                    Created\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "info-value",
    attrs: {
      "title": _vm.formatFullDate(_vm.firstDate)
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.formatShortDate(_vm.firstDate)) + "\n                ")])]), _vm._v(" "), _c('li', [_c('button', {
    on: {
      "click": function($event) {
        _vm.$emit('go-last-post')
      }
    }
  }, [_c('div', {
    staticClass: "info-label info-label-left"
  }, [_vm._v("\n                        Last reply\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "info-value",
    attrs: {
      "title": _vm.formatFullDate(_vm.lastDate)
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.formatShortDate(_vm.lastDate)) + "\n                    ")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "info-value"
  }, [_vm._v("\n                    " + _vm._s(_vm.replyCount) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "info-label"
  }, [_vm._v("\n                    Replies\n                ")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "info-value"
  }, [_vm._v("\n                    " + _vm._s(_vm.viewCount) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "info-label"
  }, [_vm._v("\n                    Views\n                ")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "info-value"
  }, [_vm._v("\n                    " + _vm._s(_vm.userCount) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "info-label"
  }, [_vm._v("\n                    Users\n                ")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "info-value"
  }, [_vm._v("\n                    " + _vm._s(_vm.likeCount) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "info-label"
  }, [_vm._v("\n                    Likes\n                ")])])]), _vm._v(" "), (_vm.showExpand) ? _c('button', {
    staticClass: "body-toggle",
    attrs: {
      "type": "button",
      "title": "Expand"
    },
    on: {
      "click": function($event) {
        _vm.isOpen = !_vm.isOpen
      }
    }
  }, [(_vm.isOpen) ? _c('i', {
    staticClass: "fa fa-chevron-up"
  }) : _c('i', {
    staticClass: "fa fa-chevron-down"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFilters),
      expression: "showFilters"
    }],
    staticClass: "filters body-section"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing || _vm.termTypes.length > 0),
      expression: "isEditing || termTypes.length > 0"
    }],
    staticClass: "terms"
  }, [_c('div', {
    staticClass: "info-label"
  }, [_vm._v("\n                    Term Types\n                ")]), _vm._v(" "), (_vm.isEditing) ? _c('multiselect', {
    attrs: {
      "options": _vm.termTypeOptions,
      "value": _vm.termTypes
    },
    on: {
      "input": function($event) {
        _vm.$emit('update:termTypes', $event)
      }
    }
  }) : _c('ul', _vm._l((_vm.sortedTermTypes), function(tt) {
    return _c('li', [_vm._v("\n                        " + _vm._s(_vm.formatTermType(tt)) + "\n                    ")])
  }))], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPaths),
      expression: "showPaths"
    }],
    staticClass: "paths"
  }, [_c('div', {
    staticClass: "info-label"
  }, [_vm._v("\n                    Paths\n                ")]), _vm._v(" "), (_vm.isEditing) ? _c('multiselect', {
    attrs: {
      "options": _vm.pathOptions,
      "value": _vm.pathIds
    },
    on: {
      "input": function($event) {
        _vm.$emit('update:pathIds', $event)
      }
    }
  }) : _c('ul', _vm._l((_vm.pathIds), function(id) {
    return _c('li', [_vm._v("\n                        " + _vm._s(_vm.formatPathId(id)) + "\n                    ")])
  }))], 1), _vm._v(" "), (_vm.isEditing || _vm.assignmentIds.length > 0) ? _c('div', {
    staticClass: "assignments"
  }, [_c('div', {
    staticClass: "info-label"
  }, [_vm._v("\n                    Assignments\n                ")]), _vm._v(" "), (_vm.isEditing) ? _c('div', [_c('ul', _vm._l((_vm.assignmentIds), function(asnId) {
    return _c('li', [_c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "flex-full"
    }, [_vm._v("\n                                    " + _vm._s(_vm.formatAssignmentId(asnId)) + "\n                                ")]), _vm._v(" "), _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deselectAssignment(asnId)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    })])])])
  })), _vm._v(" "), _c('search-select', {
    attrs: {
      "options": _vm.assignmentOptions,
      "multiple": true,
      "value": _vm.assignmentIds
    },
    on: {
      "input": function($event) {
        _vm.$emit('update:assignmentIds', $event)
      }
    }
  })], 1) : _c('ul', _vm._l((_vm.assignmentIds), function(id) {
    return _c('li', [_vm._v("\n                        " + _vm._s(_vm.formatAssignmentId(id)) + "\n                    ")])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing || _vm.tags.length > 0),
      expression: "isEditing || tags.length > 0"
    }],
    staticClass: "tags body-section"
  }, [_c('div', {
    staticClass: "info-label"
  }, [_vm._v("\n                Tags\n            ")]), _vm._v(" "), (_vm.isEditing) ? _c('tag-select', {
    attrs: {
      "search": _vm.searchTags,
      "canCreate": true
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  }) : _c('tag-list', {
    attrs: {
      "value": _vm.tags
    }
  })], 1), _vm._v(" "), (_vm.isEditing && _vm.canSave) ? _c('div', {
    staticClass: "action-btns body-section"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('save')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v("\n                Save\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('cancel')
      }
    }
  }, [_vm._v("\n                Cancel\n            ")])]) : _vm._e(), _vm._v(" "), (!_vm.isEditing && _vm.canEdit) ? _c('div', {
    staticClass: "action-btns body-section"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('edit')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v("\n                Edit\n            ")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8367edca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/forum/thread-summary.vue
// module id = 2095
// module chunks = 2